import "../styles/component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

function PediatricSurgery() {
  return (
        <>
            <section className="general-surgery hide-on-mobile">
                <img
                    src={require("../assets/img/services/big-5.png")}
                    alt="General Surgery"
                    className="top-band-img"
                />
            </section>
            <section className="general-surgery-content">
                <div className="1stblock">
                    <span className="title">What is Paediatric Surgery?</span>
                    <p>
                        Paediatric surgery provides surgical care for infants and children, addressing conditions that require specialised medical attention.
                    </p>
                </div>
                <div className="general-surgery-row">
                    <div className="general-surgery-col general-surgery-col-1">
                        <span className="subtitle">Services Include:</span>
                        <ul className="general-surgery-list">
                            <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Evaluation and surgical treatment of paediatric conditions
                            </li>
                            <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Coordinated care with paediatric specialists
                            </li>
                            {/* <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Post-trauma and post-surgical reconstruction
                            </li> */}
                        </ul>
                    </div>
                    <div className="general-surgery-col general-surgery-col-2">
                        <span className="subtitle">Why This Service Matters</span>
                        <p>Children require age-appropriate surgical care and monitoring to support safe treatment and recovery.</p>
                    </div>
                </div>
            </section>
           
        </>
    )
}

export default PediatricSurgery;
